import Pagination from "react-js-pagination";
import React from "react";

export default function PillveryPagination(props) {
  const { pagination, onPageChange, totalItemsCount } = props;

  let showingData = pagination?.pageSize * pagination?.activePage;

  if (showingData > pagination?.total) {
    showingData = pagination?.total;
  }

  if (!pagination?.total) {
    showingData = 0;
  }

  return (
    <div
      className="d-flex justify-content-between align-items-center flex-wrap"
      style={{ marginBottom: 20 }}
    >
      <nav>
        <Pagination
          innerClass="pagination flex-wrap pagination-separated pagination-dark mt-3 mb-0"
          activePage={pagination?.activePage}
          itemsCountPerPage={pagination?.pageSize}
          totalItemsCount={pagination?.total || 0}
          pageRangeDisplayed={5}
          itemClass="page-item"
          linkClass="page-link"
          onChange={onPageChange?.bind()}
          firstPageText="first"
          lastPageText="last"
          nextPageText="next"
          prevPageText="prev"
          activeClass="btn-primary"
          hideDisabled={false}
        />
      </nav>
      <p className="text-muted mt-3 mb-0 ml-3 ml-md-0 d-none d-md-block">
        Showing {showingData} out of {pagination?.total || 0}
      </p>
    </div>
  );
}
